import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const BLIK_DIRECT: PaymentMethod = {
    id: PAYMENT_METHOD_ID.BlikDirect,
    name: 'blik',
    displayName: 'BLIK'
};
